import { queryOptions, type UseQueryOptions, useQuery } from '@tanstack/react-query';
import type { TimelineLayoutDTO } from '@tempo-io/roadmap-dto';
import { roadmappingQueryKeys } from '@/lib/query-keys/roadmapping';
import { headerToPropertySelector } from '@/lib/utils/roadmapping/commonLayoutUtils';
import { getAndValidateTimelineLayout } from '@/lib/utils/roadmapping/timelineLayout';

const getTimelineLayoutQueryOptions = (
  viewId: number,
  visualizationId: number,
  options?: Partial<UseQueryOptions<TimelineLayoutDTO, Error, TimelineLayoutDTO>>,
) =>
  queryOptions({
    queryKey: roadmappingQueryKeys.timelineLayout.detail(viewId, visualizationId),
    queryFn: () => getAndValidateTimelineLayout(viewId, visualizationId),
    retry: false,
    refetchOnMount: false,
    enabled: Boolean(viewId) && Boolean(visualizationId),
    ...options,
  });

export const useTimelineLayout = (
  viewId: number,
  visualizationId: number,
  options?: Partial<UseQueryOptions<TimelineLayoutDTO, Error, TimelineLayoutDTO>>,
) => {
  return useQuery(getTimelineLayoutQueryOptions(viewId, visualizationId, options));
};

export const useTimelineLayoutHeader = (viewId: number, visualizationId: number) => {
  return useQuery({
    ...getTimelineLayoutQueryOptions(viewId, visualizationId),
    select: (data) => ({
      header1: headerToPropertySelector(data.header1),
      header2: headerToPropertySelector(data.header2),
      itemLevelId: data.itemLevelId,
    }),
  });
};
